/*!
 * Copyright Optimus Ride 2019
 */

import Auth from '../auth/abstract-auth';
import PlacesServiceConsumer from './places'
import RemoteMonitorServiceConsumer from './remote-monitor';
import ReservationServiceConsumer from './reservation';
import SiteServiceConsumer from './site';
import StationServiceConsumer from './station';
import UserServiceConsumer from './user';

export interface API {
  places:PlacesServiceConsumer;
  remoteMonitor: RemoteMonitorServiceConsumer;
  reservation: ReservationServiceConsumer;
  site: SiteServiceConsumer;
  station: StationServiceConsumer;
  user: UserServiceConsumer;
}

const APIs = (auth: Auth, hostname?: string, oriApiKey?: string): API => {
  if (hostname === undefined) {
    throw new Error('hostname is required.');
  }

  return {
    places: new PlacesServiceConsumer(auth, hostname, oriApiKey),
    remoteMonitor: new RemoteMonitorServiceConsumer(auth, hostname, oriApiKey),
    reservation: new ReservationServiceConsumer(auth, hostname, oriApiKey),
    site: new SiteServiceConsumer(auth, hostname, oriApiKey),
    station: new StationServiceConsumer(auth, hostname, oriApiKey),
    user: new UserServiceConsumer(auth, hostname, oriApiKey),
  };
};

export default APIs;
